/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 1229
// module chunks = 0